// src/context/LocationContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [position, setPosition] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setPosition({ lat: latitude, lng: longitude });
      },
      (err) => {
        setError(err.message);
      }
    );
  }, []);

  return (
    <LocationContext.Provider value={{ position, error }}>
      {children}
    </LocationContext.Provider>
  );
};

// 🔧 쉽게 쓰도록 커스텀 훅도 함께 export
export const useLocation = () => useContext(LocationContext);
